const { onVisitorChoicesConsentSetting } = require('../../common/utils/consentEvents');
const { pushToDataLayer } = require('../../common/utils/consentManager');

const createVisitorConsentHandler = (ev) => function handleVisitorConsent() {
  return pushToDataLayer(ev);
};

/**
 * Send a new event to DataLayer
 * @param {EventGA4|null} ev - The event to send
 */
function pushEvent(ev) {
  if (ev !== null) {
    onVisitorChoicesConsentSetting(createVisitorConsentHandler(ev));
  }
}

module.exports = pushEvent;
